function observeBodyForCollectionGrid() {
  const bodyObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const collectionBodyGrid = document.querySelector('.collection--body--grid');
          if (collectionBodyGrid) {
            observer.disconnect();
            initializeMutationObserver(collectionBodyGrid);
          }
        }
      });
    });
  
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
    
  function initializeMutationObserver(collectionBodyGrid) {
    // Check if banners exist in the DOM initially
    const initialBanner = document.querySelector('.collection-grid-banner');
    const initialHorizontalBanner = document.querySelector('.collection-grid-banner-horizontal');

    // If both banners are missing, do not start the observer
    if (!initialBanner && !initialHorizontalBanner) {
      return;
    }

    const collectionObserver = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const productAdded = addedNodes.some(node => node.classList && node.classList.contains('product--root'));
          if (productAdded) {
            // Only move banners if they exist and are not already moved
            const movedBanner = document.querySelector('.collection--body--grid .collection-grid-banner');
            const movedHorizontalBanner = document.querySelector('.collection--body--grid .collection-grid-banner-horizontal');

            if (initialBanner && !movedBanner) {
              insertBannerAsFirstElement(collectionBodyGrid);
            }
            if (initialHorizontalBanner && !movedHorizontalBanner) {
              insertHorizontalBanner(collectionBodyGrid);
            }

            // Check if all required banners are already moved
            const isBannerPlaced = initialBanner ? !!document.querySelector('.collection--body--grid .collection-grid-banner') : true;
            const isHorizontalBannerPlaced = initialHorizontalBanner ? !!document.querySelector('.collection--body--grid .collection-grid-banner-horizontal') : true;

            // If all banners are in place, disconnect the observer
            if (isBannerPlaced && isHorizontalBannerPlaced) {
              observer.disconnect();
            }
          }
        }
      }
    });

    const config = { childList: true, subtree: true };
    collectionObserver.observe(collectionBodyGrid, config);
  }

  
  function insertBannerAsFirstElement(collectionBodyGrid) {
    const banner = document.querySelector('.collection-grid-banner');
    const bannerClone = banner.cloneNode(true);
    const firstProduct = collectionBodyGrid.querySelector('.product--root');
    const fourthProduct = collectionBodyGrid.querySelectorAll('.product--root')[3];
    const screenWidth = window.innerWidth;

    if (fourthProduct && screenWidth <= 768) {
      if (bannerClone) {
        fourthProduct.insertAdjacentElement('afterend', bannerClone);
        bannerClone.classList.add('mobile');
      }
    } else if (bannerClone && firstProduct) {
      firstProduct.insertAdjacentElement('beforebegin', bannerClone);
    } else if (bannerClone) {
      collectionBodyGrid.insertBefore(bannerClone, collectionBodyGrid.firstChild);
    }

    document.querySelector('.sortby-select').addEventListener('change', function() {
      window.location.reload();
    });
  }

function insertHorizontalBanner(collectionBodyGrid) {
  const horizontalBanner = document.querySelector('.collection-grid-banner-horizontal');
  const elementClone = horizontalBanner.cloneNode(true);
  const productItems = collectionBodyGrid.querySelectorAll('.product--root');

  if (elementClone && productItems.length >= 14) {
    const lastProductBeforeBanner = productItems[13];

    lastProductBeforeBanner.insertAdjacentElement('afterend', elementClone);
  }
}

observeBodyForCollectionGrid();
